import { IJoinedProblem, IVuexRootState } from '@/types';

export default {
  // return all cards in a deck
  cardsInDeck:
    (state: IVuexRootState) =>
    (deckId: number): IJoinedProblem[] =>
      state.joinedProblems.filter((jp) => jp.deckId === deckId),

  // return the `joinedProblems` record that has problemId
  getJoinedProblemsRecord:
    (state: IVuexRootState) =>
    (problemId: number): IJoinedProblem | undefined =>
      state.joinedProblems.find((pb) => pb.problemId === problemId),

  isProblemInMyTsBook:
    (state: IVuexRootState) =>
    (problemId: number): boolean =>
      !!state.joinedProblems.find((pb) => pb.problemId === problemId)!.isSelectedForStudy,
};
